/**
 * `@eis/dataservice-sdk` — the generated client for dataservice (a platform service).
 *
 * `./generated` comes from api/openapi/dataservice.v1.openapi.yaml via `pnpm gen:sdk`; never hand-edited, diffed by
 * `make gen-check` (rule 26). Built with `createEisClient`, so every platform default is ON:
 * bearer auth, traceparent (T-13), ETag/If-Match with typed conflicts (T-12) and the session
 * refresh/replay (SDD-019). Scaffolded by `pnpm new:sdk` (sdk/README.md "Adding an SDK").
 */
import { createEisClient, type EisClient, type EisClientOptions } from '@eis/sdk-runtime';
import type { paths } from './generated/dataservice.v1';

export type * as DataApi from './generated/dataservice.v1';

export {
  ConflictError,
  isConflictError,
  createEtagStore,
  type ConflictKind,
  type EtagStore,
  type TokenProvider,
  type TraceparentProvider,
  type EisClientOptions,
  createSessionRefreshMiddleware,
  isSafeToReplay,
  type SessionRefreshOptions,
} from '@eis/sdk-runtime';

export type DataServiceClient = EisClient<paths>;

export function createDataServiceClient(options: EisClientOptions): DataServiceClient {
  return createEisClient<paths>(options);
}
